<div class="subscriptions-page">
  <div class="container-fluid clearfix">
    <div class="d-flex flex-wrap justify-content-center">
      <mat-card
        class="card-style"
        [hidden]="isConfirmed"
        style="max-width: 500px"
      >
        <div class="row center-container">
          <div class="col-sm-12">
            <div class="row" style="max-width: 350px">
              <div class="col-sm-12">
                <label id="options-radio-group-label">
                  <h4 class="downloads-page">Subscribe to</h4>
                </label>
                <!-- MP3//AAC -->
                <mat-radio-group
                  aria-labelledby="options-radio-group-label"
                  class="options-radio-format-group"
                  [formControl]="formatOptionCtrl"
                >
                  <mat-radio-button
                    color="warn"
                    class="options-radio-format-button"
                    style="margin-top: 10px"
                    *ngFor="let option of formatOptions"
                    [value]="option"
                  >
                    {{ option.name }}
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>

            <!-- Station Dropbox -->
            <div class="row" style="max-width: 350px; margin-top: 15px">
              <div class="col-sm-12">
                <div class="col-sm-auto p-0">
                  <app-single-dropbox
                    class="single-dropbox"
                    [showStationBadge]="true"
                    [isDisabled]="disableStationsDropBox"
                    [allowMultiple]="false"
                    cssClassToApply="dropbox-w-300 single-dropbox-custom"
                    popupPositionLeft="44"
                    [(ngModel)]="selectedStation"
                    placeholder="Select Station"
                    placeholderLabel="Find a station..."
                    noEntriesFoundLabel="No station found"
                    (selectionChanged)="selectStation($event)"
                    #stationMulti
                  >
                  </app-single-dropbox>
                </div>
                <!-- Audio Source Radio Button -->
                <div>
                  <app-single-dropbox
                    class="single-dropbox"
                    [isDisabled]="isStationSourcesDropboxDisable"
                    [allowMultiple]="false"
                    cssClassToApply="dropbox-w-300 single-dropbox-custom"
                    popupPositionLeft="44"
                    [(ngModel)]="selectedStationSource"
                    placeholder="Select Source"
                    placeholderLabel="Find a source..."
                    noEntriesFoundLabel="No source found"
                    (selectionChanged)="selectStationSource($event)"
                    #stationSourceMulti
                  >
                  </app-single-dropbox>
                </div>
              </div>
            </div>

            <!--Start datepicker-->
            <div class="row" style="max-width: 350px">
              <div class="col-sm-12">
                <mat-label style="font-size: 12px" #matLabel
                  >Start Time</mat-label
                >
                <mat-label style="font-size: 10px" #matLabel>{{
                  selectedStationTimezone
                    ? " (" + selectedStationTimezone + ")"
                    : ""
                }}</mat-label>
                <ng2-flatpickr
                  #startDatePicker
                  [config]="startDateOptions"
                  [formControl]="startDateTimeCtrl"
                  [placeholder]="startDatePlaceholder"
                >
                </ng2-flatpickr>
              </div>
            </div>

            <!--End datepicker-->
            <div class="row" style="max-width: 350px; margin-top: 15px">
              <div class="col-sm-12">
                <mat-label style="font-size: 11px" #matLabel
                  >End Time</mat-label
                >
                <mat-label style="font-size: 10px" #matLabel>{{
                  selectedStationTimezone
                    ? " (" + selectedStationTimezone + ")"
                    : ""
                }}</mat-label>
                <ng2-flatpickr
                  #endDatePicker
                  [config]="endDateOptions"
                  [formControl]="endDateTimeCtrl"
                  [placeholder]="endDatePlaceholder"
                >
                </ng2-flatpickr>
              </div>
            </div>

            <!-- Duration -->
            <div class="row" style="max-width: 350px; margin-top: 15px">
              <div class="col-sm-12">
                <h4>
                  Duration
                  <span class="slider" [hidden]="!formatOptionCtrl.value"
                    >(Max {{ sliderMax }} min)</span
                  >
                </h4>
              </div>
            </div>

            <!--Duration Slider-->
            <div class="row" style="max-width: 350px; margin-top: 15px">
              <div class="col-sm-9 float-left">
                <mat-slider
                  [formControl]="sliderCtrl"
                  (change)="onSliderChange($event)"
                  style="width: 245px"
                  [max]="sliderMax"
                  min="1"
                  step="1"
                  color="warn"
                  thumbLabel="true"
                >
                </mat-slider>
              </div>

              <!--Duration input field text-->
              <div class="col-sm-3 float-right">
                <mat-form-field class="value">
                  <input
                    #sliderInputBox
                    [formControl]="sliderCtrl"
                    (input)="onSliderChange($event.target)"
                    matInput
                    type="number"
                    min="1"
                  />
                </mat-form-field>
              </div>
            </div>

            <!--Checkboxes weekday-->
            <div class="div-space">
              <ul class="row">
                <li
                  class="week-days-list"
                  *ngFor="let weekDay of weekDaysOptions"
                >
                  <mat-checkbox
                    class="check-box-color"
                    [(ngModel)]="weekDay.selected"
                    color="warn"
                    (change)="fillWeekDate(weekDay)"
                  >
                    {{ weekDay.name }}
                  </mat-checkbox>
                </li>
              </ul>
            </div>
            <!-- EMAIL chip-->
            <div class="div-space">
              <mat-form-field
                class="example-chip-list"
                style="width: 315px"
                appearance="fill"
              >
                <mat-label>Emails</mat-label>
                <mat-chip-list #chipList aria-label="Emails">
                  <mat-chip
                    *ngFor="let email of emailCtrlArray.value"
                    [selectable]="selectable"
                    [removable]="removable"
                    (removed)="removeEmail(email)"
                  >
                    {{ email }}
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip>
                  <input
                    placeholder="New Email..."
                    [matChipInputFor]="chipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="addEmail($event)"
                    [matChipInputAddOnBlur]="'true'"
                    [formControl]="emailCtrl"
                  />
                </mat-chip-list>
                <mat-error *ngIf="emailCtrl.hasError('email')">
                  Please enter a valid email address
                </mat-error>
              </mat-form-field>
            </div>
            <!--Btns Clear/Submit-->
            <div class="row" class="div-space">
              <div class="col-sm-12 p-0">
                <button
                  mat-button
                  class="float-left"
                  (click)="clear()"
                  data-testid="clear"
                >
                  {{ clearBtnText }}
                </button>
                <button
                  data-testid="subscribe"
                  [class.primary-button-disabled]="!myForm.valid"
                  [class.primary-button]="myForm.valid"
                  [disabled]="!myForm.valid"
                  mat-button
                  (click)="submit()"
                  class="float-right no-outline"
                >
                  {{ subscribeBtnText }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </mat-card>

      <mat-card class="card-style" [hidden]="!isConfirmed">
        <div class="row center-container">
          <div class="col-sm-12">
            <!-- Success -->
            <p *ngIf="isSuccess" data-testid="successful-message">
              Thank you!<br />
              You’ve <span [innerHTML]="displayCreateEdit"></span> to
              <b>{{ displayAudioFormatName }}</b> <br />
              from
              <b
                >{{ displayedStationName }} ({{displayStationSourceName}})</b
              ><br />
              starting at
              <b>{{ displayedDateTime }} ({{ selectedStationTimezone }})</b
              ><br />
              for a duration of <b>{{ sliderValue }}</b> minutes<br />
              every <span [innerHTML]="stringWeekDays"></span>.
            </p>

            <!--Duplicated-->
            <p
              style="max-width: 500px; text-align: center"
              *ngIf="isDuplicated"
              data-testid="successful-message"
            >
              Sorry, you have already subscribed to this station
              <b
                >{{ displayedStationName }} ({{displayStationSourceName}})</b>
              starting at
              <b>{{ displayedDateTime }} ({{ selectedStationTimezone }})</b> for
              a duration of <b>{{ sliderValue }}</b> minutes every
              <span [innerHTML]="stringWeekDays"></span>.
            </p>

            <!-- Error -->
            <p
              style="max-width: 500px; text-align: center"
              *ngIf="!isSuccess && !isDuplicated"
            >
              Sorry, something went wrong. Please try again.
            </p>
          </div>
        </div>
        <div class="row center-container button-row">
          <div>
            <button mat-button (click)="backToSubscriptions()">
              Back to Subscriptions
            </button>
          </div>
          <a routerLink="/search">
            <button mat-button data-testid="back-search-button">
              Back to Search
            </button>
          </a>
        </div>
        <button
          mat-icon-button
          class="close-button"
          (click)="backToSubscriptions()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-card>

      <!--TABLE-->
      <mat-card
        class="card-style"
        style="max-width: 1200px"
        [hidden]="isConfirmed"
      >
        <div class="header-available-subscription">
          <h2>My Subscriptions</h2>
        </div>
        <div class="table-container">
          <table
            mat-table
            [dataSource]="audioSubscriptionsList"
            data-testid="subscriptions-table"
            *ngIf="
              audioSubscriptionsList && audioSubscriptionsList.length;
              else noSubscriptions
            "
          >
            <!-- Station Column -->
            <ng-container matColumnDef="stationName">
              <th mat-header-cell *matHeaderCellDef class="header">Station</th>
              <td mat-cell *matCellDef="let subs">
                {{ subs.stationName }}
              </td>
            </ng-container>

            <!-- Source Column -->
            <ng-container matColumnDef="stationSource">
              <th mat-header-cell *matHeaderCellDef class="header">Source</th>
              <td mat-cell *matCellDef="let subs">
                {{ subs.stationSource.name }}
              </td>
            </ng-container>

            <!-- Start Time Column -->
            <ng-container matColumnDef="startTime">
              <th mat-header-cell *matHeaderCellDef class="header">Start Time</th>
              <td mat-cell *matCellDef="let subs">{{ subs.startTime }}</td>
            </ng-container>

            <!-- End Time Column -->
            <ng-container matColumnDef="endTime">
              <th mat-header-cell *matHeaderCellDef class="header">End Time</th>
              <td mat-cell *matCellDef="let subs">{{ subs.endTime }}</td>
            </ng-container>

            <!-- Duration Column -->
            <ng-container matColumnDef="duration">
              <th mat-header-cell *matHeaderCellDef class="header">Duration</th>
              <td mat-cell *matCellDef="let subs">{{ subs.duration }} min</td>
            </ng-container>

            <!-- timezone Column -->
            <ng-container matColumnDef="timezone">
              <th mat-header-cell *matHeaderCellDef class="header">Timezone</th>
              <td mat-cell *matCellDef="let subs">
                {{ subs.timezone }}
              </td>
            </ng-container>

            <!-- Format Column -->
            <ng-container matColumnDef="format">
              <th mat-header-cell *matHeaderCellDef class="header">Format</th>
              <td mat-cell *matCellDef="let subs">{{ subs.audioFormat }}</td>
            </ng-container>

            <!-- Days Column -->
            <ng-container matColumnDef="days">
              <th mat-header-cell *matHeaderCellDef class="header">Days</th>
              <td mat-cell *matCellDef="let subs">
                <span [innerHTML]="subs.weekDays"></span>
              </td>
            </ng-container>

            <!-- Last Run -->
            <ng-container matColumnDef="lastRun">
              <th mat-header-cell *matHeaderCellDef class="header">Last Run</th>
              <td mat-cell *matCellDef="let subs">
                {{ subs.lastRunFormatted }}
              </td>
            </ng-container>

            <!-- EMAIL Column -->
            <ng-container matColumnDef="emails">
              <th mat-header-cell *matHeaderCellDef class="header"></th>
              <td mat-cell *matCellDef="let subs">
                <button
                  mat-icon-button
                  class="table-btn"
                  matTooltip="Emails"
                  (click)="showEmails(subs)"
                >
                  <mat-icon color="warn">email</mat-icon>
                </button>
              </td>
            </ng-container>

            <!-- Edit Column -->
            <ng-container matColumnDef="edit">
              <th mat-header-cell *matHeaderCellDef class="header"></th>
              <td mat-cell *matCellDef="let subs">
                <button
                  mat-icon-button
                  class="table-btn"
                  matTooltip="Edit"
                  (click)="edit(subs)"
                >
                  <mat-icon color="warn">edit</mat-icon>
                </button>
              </td>
            </ng-container>

            <!-- Delete Column -->
            <ng-container matColumnDef="delete">
              <th mat-header-cell *matHeaderCellDef class="header"></th>
              <td mat-cell *matCellDef="let subs">
                <button
                  mat-icon-button
                  class="table-btn"
                  (click)="delete(subs)"
                  matTooltip="Delete"
                >
                  <mat-icon color="warn">delete</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumns; sticky: true"
            ></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              [class.row-selected]="selection.isSelected(row)"
            ></tr>
          </table>

          <ng-template class="no-downloads" #noSubscriptions>
            <p>No available subscriptions</p>
          </ng-template>
        </div>
      </mat-card>
    </div>
  </div>
</div>
